export const getUniqueArray = (array: any[], key?: string) =>
  array
    .map((item) => (key ? item[key] : item))
    .filter((item, index, self) => self.indexOf(item) === index);
